import React, { useState } from "react";
import "../styles/Services.css";
import { Laptop } from "lucide-react";
import {
  HiMiniPresentationChartLine,
  HiMiniServerStack,
  HiArrowSmallRight,
  HiMiniXCircle,
} from "react-icons/hi2";

const Services = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ details: [] });

  const servicesData = [
    {
      title: "Frontend",
      subtitle: "Developer",
      details: [
        "Developing interactive web applications",
        "Enhancing user experience with seamless performance",
        "Implementing responsive designs",
        "Optimizing web performance",
      ],
      icons: () => <Laptop />,
    },
    {
      title: "Backend",
      subtitle: "Developer",
      details: [
        "Building scalable server-side applications",
        "Integrating databases and APIs",
        "Ensuring data security and integrity",
        "Optimizing server performance",
      ],
      icons: () => <HiMiniServerStack />,
    },
    {
      title: "UI/UX",
      subtitle: "Designer",
      details: [
        "Providing designs for better experience",
        "Creating user-friendly interfaces",
        "Implementing responsive designs",
        "Optimizing web performance",
      ],
      icons: () => <HiMiniPresentationChartLine />,
    },
  ];

  const handleViewMore = (details) => {
    console.log("Opening modal with details:", details);
    setModalContent({ details });
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <section id="services" className="services">
      <h2>Services</h2>
      <p className="services-subtitle">What I offer</p>
      <div className="services-grid">
        {servicesData.map((service, index) => (
          <div key={index} className="service-card">
            <i>{service.icons()}</i>
            <h3>{service.title}</h3>
            <p>{service.subtitle}</p>
            <button
              className="view-more-button"
              onClick={() => handleViewMore(service.details)}
            >
              View More <HiArrowSmallRight />
            </button>
          </div>
        ))}
      </div>

      {/* Modal */}
      {modalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="service-modal" onClick={(e) => e.stopPropagation()}>
            <ul>
              {modalContent.details.map((detail, index) => (
                <li key={index}>{detail}</li>
              ))}
            </ul>
            <button className="close-button" onClick={closeModal}>
              <HiMiniXCircle />
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Services;
